// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./images/ohsnap.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signavio-ui-img-oh-snap {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 512px;
  height: 480px;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@signavio/ui/assets/images.css"],"names":[],"mappings":"AAAA;EACE,yDAA0C;EAC1C,YAAY;EACZ,aAAa;AACf","sourcesContent":[".signavio-ui-img-oh-snap {\n  background-image: url('images/ohsnap.png');\n  width: 512px;\n  height: 480px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
